import React, { createRef } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import logo from '../img/logo.png'
import CardMedia from '@material-ui/core/CardMedia';
import LanguageIcon from '@material-ui/icons/Language';
import Link from '@material-ui/core/Link'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuIcon from '@material-ui/icons/Menu';
import { ClickAwayListener, Divider, Grow, IconButton, MenuList, Paper, Popper, Typography } from '@material-ui/core';
import i18n from '../i18n';
import { withNamespaces } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom'


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  logo: {
    maxWidth: 200,
    Width: "20%"
  },
  link: {
    color: "black"
  }
}));

function ButtonAppBar({ t }) {
  const classes = useStyles();
  const theme = useTheme();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [openLanguage, setOpenLanguage] = React.useState(false);

  const anchorRef = React.useRef(null);
  const anchorLanguageRef = React.useRef(null);
  const menuXsRef = createRef()
  const menuSmUpRef = createRef()

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  }

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleLanguageToggle = () => {
    setOpenLanguage((prevOpenLanguage) => !prevOpenLanguage);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const handleLanguageClose = (event) => {
    if (anchorLanguageRef.current && anchorLanguageRef.current.contains(event.target)) {
      return;
    }

    setOpenLanguage(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseSmMenu = () => {
    setAnchorEl(null);
  };

  const HomepageLink = React.forwardRef((props, ref) => (
    <RouterLink ref={ref} to="/" {...props} />
  ));

  const StandardizeProductReportCardLink = React.forwardRef((props, ref) => (
    <RouterLink ref={ref} to="/standardize-product-report-card" {...props} />
  ));

  const InstantInsurancePlanningLink = React.forwardRef((props, ref) => (
    <RouterLink ref={ref} to="/instant-insurance-planning" {...props} />
  ));

  const AiBioPersonalSolutionLink = React.forwardRef((props, ref) => (
    <RouterLink ref={ref} to="/ai-bio-personal-solution" {...props} />
  ));

  const AboutUsMainSolutionLink = React.forwardRef((props, ref) => (
    <RouterLink ref={ref} to="/about-us-main" {...props} />
  ));

  return (
    <div className={classes.root}>
      <AppBar color="inherit">
        <Toolbar>
          <CardMedia className={classes.title}>
            <Link underline="none" component={HomepageLink}>
              <img src={logo} className={classes.logo} />
            </Link>
          </CardMedia>
          {(useMediaQuery(theme.breakpoints.up('sm')))
            ?
            <div ref={menuSmUpRef}>
              {/* <Button href="/standardize-product-report-card" style={{ textTransform: 'none' }} color="inherit">Features</Button> */}
              <Button
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                style={{ textTransform: 'none' }}
                onClick={handleToggle}
              >
                {t("feature")}
              </Button>
              <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={handleClose}>
                        <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                          <MenuItem onClick={handleClose}>
                            <Link underline="none" component={StandardizeProductReportCardLink} className={classes.link}>
                              {t("standardize-report-card")}
                            </Link>
                          </MenuItem>
                          <MenuItem onClick={handleClose}>
                            <Link underline="none" component={InstantInsurancePlanningLink} className={classes.link}>
                              {t("instant-insurance-planning")}
                            </Link>
                          </MenuItem>
                          <MenuItem onClick={handleClose}>
                            <Link underline="none" component={AiBioPersonalSolutionLink} className={classes.link}>
                              {t("ai-bio-personal-solution")}
                            </Link>
                          </MenuItem>
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
              <Button style={{ textTransform: 'none' }} color="inherit">
                <Link underline="none" component={AboutUsMainSolutionLink} className={classes.link}>
                  {t("about-us")}
                </Link>
              </Button>
              <Button disabled style={{ textTransform: 'none' }} color="inherit">{t("media")}</Button>
              <Button disabled style={{ textTransform: 'none' }} color="inherit">{t("FAQ")}</Button>
              <Button ref={anchorLanguageRef}
                aria-controls={openLanguage ? 'language-menu-list-grow' : undefined}
                aria-haspopup="true"
                style={{ textTransform: 'none' }}
                onClick={handleLanguageToggle}
                startIcon={<LanguageIcon />} variant="outlined" style={{ borderRadius: 50, textTransform: 'none' }}>
                {t("language")}
              </Button>
              <Popper open={openLanguage} anchorEl={anchorLanguageRef.current} role={undefined} transition disablePortal>
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={handleLanguageClose}>
                        <MenuList autoFocusItem={openLanguage} id="language-menu-list-grow" onKeyDown={handleListKeyDown}>
                          <MenuItem onClick={() => changeLanguage('tc')}>
                            繁體中文
                          </MenuItem>
                          <MenuItem onClick={() => changeLanguage('en')}>
                            English
                          </MenuItem>
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </div>
            :
            <div ref={menuXsRef}>
              <IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
                <MenuIcon />
              </IconButton>
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleCloseSmMenu}
              >
                <Typography style={{ textAlign: "center", fontSize: 20 }}>{t("feature")}</Typography>
                <MenuItem onClick={handleCloseSmMenu}>
                  <Link underline="none" component={StandardizeProductReportCardLink} className={classes.link}>
                    {t("standardize-report-card")}
                  </Link>
                </MenuItem>
                <MenuItem onClick={handleCloseSmMenu}>
                  <Link underline="none" component={InstantInsurancePlanningLink} className={classes.link}>
                    {t("instant-insurance-planning")}
                  </Link>
                </MenuItem>
                <MenuItem onClick={handleCloseSmMenu}>
                  <Link underline="none" component={AiBioPersonalSolutionLink} className={classes.link}>
                    {t("ai-bio-personal-solution")}
                  </Link>
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleCloseSmMenu}>
                  <Link underline="none" component={AboutUsMainSolutionLink} className={classes.link}>
                    {t("about-us")}
                  </Link>
                </MenuItem>
                <MenuItem disabled onClick={handleCloseSmMenu}>{t("media")}</MenuItem>
                <MenuItem disabled onClick={handleCloseSmMenu}>{t("FAQ")}</MenuItem>
                <Divider />
                <Typography style={{ textAlign: "center", fontSize: 20 }}>{t("language")}</Typography>
                <MenuItem onClick={() => { handleCloseSmMenu(); changeLanguage('tc'); }}>繁體中文</MenuItem>
                <MenuItem onClick={() => { handleCloseSmMenu(); changeLanguage('en') }}>English</MenuItem>
              </Menu>
            </div>
          }

        </Toolbar>
      </AppBar>
    </div>
  );
}

export default withNamespaces()(ButtonAppBar);